'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const flattenToTree = (originMenu) => {
  const getChildren = (menu, parentId) => {
    const result = menu.filter((item) => item.parentId === parentId).map((item) => {
      const children = getChildren(menu, item.id);
      return __spreadProps(__spreadValues({}, item), {
        children
      });
    });
    return result;
  };
  const tree = originMenu.filter((item) => !item.parentId).map((item) => __spreadProps(__spreadValues({}, item), { children: getChildren(originMenu, item.id) }));
  return tree;
};
const getUrlOfMenuItem = (item, isEditingMode = false) => {
  var _a, _b;
  if (isEditingMode)
    return null;
  if ((item == null ? void 0 : item.linkType) === "LINK")
    return item.href;
  if ((_a = item == null ? void 0 : item.page) == null ? void 0 : _a.isHomepage)
    return "/";
  return "/" + ((_b = item == null ? void 0 : item.page) == null ? void 0 : _b.slug);
};
const getTargetUrl = (target) => {
  if (target === "BLANK")
    return "_blank";
  return "_self";
};

exports.flattenToTree = flattenToTree;
exports.getTargetUrl = getTargetUrl;
exports.getUrlOfMenuItem = getUrlOfMenuItem;
